export default function TransactionUsageBox({ usage, type }) {
  if (!usage) {
    return (
      <div className="alert alert-secondary small mt-4">
        Carregando informações de uso...
      </div>
    );
  }
  const typeMessagesMap = {
    'PIX': {
      noun: ['transação Pix', 'transações Pix'],
      alert: 'As próximas transações Pix',
    },
    'TED': {
      noun: ['transferência TED', 'transferências TED'],
      alert: 'As próximas transferências TED',
    },
    'PAYMENT': {
      noun: ['pagamento de boleto', 'pagamentos de boleto'],
      alert: 'Os próximos pagamentos de boleto',
    },
    'EMITTED_BOLETO': {
      noun: ['emissão de boleto', 'emissões de boleto'],
      alert: 'As próximas emissões de boleto',
    }
  };

  function buildMessage({ count, singular, plural, extra = '' }) {
    const word = count === 1 ? singular : plural;
    return (
      <span>
        <strong>{count}</strong> {word} {extra}
      </span>
    );
  }

  const { used, free, remaining, tax } = usage;
  const messages = typeMessagesMap[type];
  const [singular, plural] = messages.noun;

  const isUnlimited = free === -1;

  return (
    <div className="border rounded p-3 mt-3 shadow-sm">
      <div className="d-flex align-items-center mb-2">
        <span className="me-2 fs-5">🎁</span>
        {isUnlimited ? (
          <span> Todas as {plural} são <strong>gratuitas</strong>. </span>
        ) : (
          buildMessage({ count: free, singular, plural, extra: `gratuita${free !== 1 ? 's' : ''} por mês.` })
        )}
      </div>
      <div className="d-flex align-items-center mb-2">
        <span className="me-2 fs-5">📤</span>
        {buildMessage({ count: used, singular, plural, extra: `já realizada${used !== 1 ? 's' : ''}.` })}
      </div>
      {!isUnlimited && (
        <div className="d-flex align-items-center mb-3">
          <span className="me-2 fs-5">🔓</span>
          {buildMessage({
            count: remaining,
            singular,
            plural,
            extra: `gratuita${remaining !== 1 ? 's' : ''} disponível${remaining !== 1 ? 's' : ''}.`,
          })}
        </div>
      )}

      {!isUnlimited && remaining === 0 && (
        <div className="alert alert-warning mt-3 mb-0 p-2">
          ⚠️ {messages.alert} terão custo adicional de
          <strong className="text-success"> R$ {tax.toFixed(2)}</strong> por operação.
        </div>
      )}
    </div>
  );
}
